let config = {
  emailjs: {
    serviceID: "service_zvty2ah",
    templateID: "template_hi1icdm",
    userID: "KMVhNdYGm7k5xajiW"
  }
};

export default config;
